import { TreatmentsContainerLocation } from "../ServicesContainer/TreatmentsContainerLocation.csharp";
import { TreatmentsContainerDoctor } from "./TreatmentsContainerDoctor.csharp";

export const filterByKeyword = (
  doctors: TreatmentsContainerDoctor[],
  keyword: string
) => {
  if (!keyword) {
    return doctors;
  } else {
    const lowerCaseKeyword = keyword.toLowerCase();

    return doctors.filter((d) => doctorIncludes(d, lowerCaseKeyword));
  }
};

const doctorIncludes = (doctor: TreatmentsContainerDoctor, keyword: string) => {
  return (
    checkName(doctor.fullName, keyword) ||
    checkOfferedTreatments(doctor.keywords, keyword)
  );
};

const checkName = (fullName: string, keyword: string) => {
  return fullName
    .toLowerCase()
    .split(" ")
    .some((word) => word.startsWith(keyword));
};

const checkOfferedTreatments = (
  specializationAndServices: string[],
  keyword: string
) => {
  return specializationAndServices.some((s) =>
    s.toLowerCase().startsWith(keyword)
  );
};

export const filterByLocations = (
  doctors: TreatmentsContainerDoctor[],
  locations: TreatmentsContainerLocation[]
) => {
  return doctors.filter((d) =>
    locations.some((l) => l.doctorIds.includes(d.id))
  );
};
